import { Component, ElementRef, OnInit } from '@angular/core';
import { ContentElement } from '@urbannex/storethemes';
import { ContentStatusEnum } from '../../../editor-container/editor-model';
import { ChangeContext, Options } from '@angular-slider/ngx-slider';
import { EditState } from '../../../model';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';

@Component({
  selector: 'ngx-underline-preset-popover',
  templateUrl: './underline-preset-popover.component.html',
  styleUrls: ['./underline-preset-popover.component.scss']
})
export class UnderlinePresetPopoverComponent implements OnInit{
  thicknesses:any[];
  selectedRadiusClass:string;
  selectedThickness:any;
  underlineBaseClass = "";
  content:ContentElement;
  status:ContentStatusEnum;
  service:string;
  contentElements:ContentElement[];
  contentElement:ContentElement;

  lineThicknessClasses = [
    {name:"Thickness 1",class:"underline-thickness-1"},
    {name:"Thickness 1",class:"underline-thickness-2"},
    {name:"Thickness 1",class:"underline-thickness-3"},
    {name:"Thickness 1",class:"underline-thickness-4"}
  ]

  lineDistanceClasses = [
    {name:"No Border",class:"none",cssValue:"0",value:"0"},
    {name:"Distance 1",class:"distance-thight",cssValue:"1px",value:"1"},
    {name:"Distance 2",class:"distance-close",cssValue:"2px",value:"2"},
    {name:"Distance 3",class:"distance-normal",cssValuelue:"3px",value:"3"},
    {name:"Distance 4",class:"distance-far",cssVvalue:"4px",value:"4"}
  ]

  thickValue:number = 0;
  thickOptions:Options = {
     floor:0,
     ceil:10,
     step:1  
  }
  distanceOptions:Options = {
    floor:0,
    ceil:10,
    step:1 
 }
 distanceValue:number = 0;

  constructor(private cellEditorStoreService:CellEditorStoreService,
    private sectionBuilderStoreService:SectionBuilderStoreService,
    private el:ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    if(this.status){
      switch (this.status) {
        case ContentStatusEnum.CTNT_INITIAL_DRAFT:
          this.service = "sectionBuilder";
          break;
        case ContentStatusEnum.CTNT_FINAL_DRAFT:
          this.service = "cellEditor";
          break;      
        default:
          this.service = "cellEditor"
          break;
      }
    }else{
      this.service = "cellEditor"
    }
    let popoverContainer:HTMLElement = this.el.nativeElement.closest('NB-POPOVER');
    popoverContainer.style.borderColor = "#808186";
    this.selectedThickness = this.lineThicknessClasses[0];
  }

  onThicknessChange(e){
    this.content.underLineThickness = e.value+"px";
    if(this.service == "cellEditor"){
      this.cellEditorStoreService.updateActiveSelector(this.content);
      this.cellEditorStoreService.updateSelectorPosChange(e.value+"px");
    }else if(this.service == "sectionBuilder"){
      this.sectionBuilderStoreService.updateContent(this.content);
    }
  }

  onThicknessUserChange(changeContext: ChangeContext){
    this.content.underLineThickness = changeContext.value+"px";
    if(this.service == "cellEditor"){
      this.cellEditorStoreService.updateActiveSelector(this.content);
      this.cellEditorStoreService.updateSelectorPosChange(changeContext.value+"px");
    }else if(this.service == "sectionBuilder"){
      this.sectionBuilderStoreService.updateContent(this.content);
    }
  }
  onThicknessUserChangeStart(changeContext: ChangeContext){
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
    console.log({start:changeContext.value})
  }

  onThicknessUserChangeEnd(changeContext: ChangeContext){
    console.log({end:changeContext.value});
    /* console.log(this.thicknesses[changeContext.value  - 1]);
    let choice = this.thicknesses[changeContext.value  - 1]; */
    this.content.underLineThickness = changeContext.value+"px";
    if(this.service == "cellEditor"){
      this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
        let contentElement = contentElements.find(element => element.elId == this.content.elId);
        contentElement.underLineThickness = changeContext.value+"px";
        this.cellEditorStoreService.updateContentElements(contentElements);
      });
    }else{
      this.sectionBuilderStoreService.updateContent(this.content);
      this.sectionBuilderStoreService.updateEditState(EditState.UPDATED)
    }
    
    
  }

  onDistanceUserChange(changeContext: ChangeContext){
    console.log(changeContext.value);
    //this.marginBottom = changeContext.value;
  }
  onDistanceUserChangeStart(changeContext: ChangeContext){
    console.log({start:changeContext.value})
    this.sectionBuilderStoreService.updateEditState(EditState.EDITING)
  }
  onDistanceUserChangeEnd(changeContext: ChangeContext){
    this.content.underLineDistance = changeContext.value+"px";
    if(this.service == "cellEditor"){
      this.cellEditorStoreService.updateActiveSelector(this.content);
      //this.cellEditorStoreService.updateSelectorPosChange(e.value);
    }else if(this.service == "sectionBuilder"){
      this.sectionBuilderStoreService.updateContent(this.content);
    }
    this.sectionBuilderStoreService.updateEditState(EditState.UPDATED)
/* 
    this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
      let contentElement = contentElements.find(element => element.elId == this.content.elId);
      
      this.cellEditorStoreService.updateContentElements(contentElements);
      this.cellEditorStoreService.updateSelectorPosChange(changeContext.value+"rem");
    }) */
  }
}
